/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameSteamDataSupportInfo } from './OWGameSteamDataSupportInfo';
import {
    OWGameSteamDataSupportInfoFromJSON,
    OWGameSteamDataSupportInfoFromJSONTyped,
    OWGameSteamDataSupportInfoToJSON,
    OWGameSteamDataSupportInfoToJSONTyped,
} from './OWGameSteamDataSupportInfo';
import type { OWGameSteamDataPlatforms } from './OWGameSteamDataPlatforms';
import {
    OWGameSteamDataPlatformsFromJSON,
    OWGameSteamDataPlatformsFromJSONTyped,
    OWGameSteamDataPlatformsToJSON,
    OWGameSteamDataPlatformsToJSONTyped,
} from './OWGameSteamDataPlatforms';
import type { OWGameSteamDataPcRequirements } from './OWGameSteamDataPcRequirements';
import {
    OWGameSteamDataPcRequirementsFromJSON,
    OWGameSteamDataPcRequirementsFromJSONTyped,
    OWGameSteamDataPcRequirementsToJSON,
    OWGameSteamDataPcRequirementsToJSONTyped,
} from './OWGameSteamDataPcRequirements';

/**
 * Raw Steam API data
 * @export
 * @interface OWGameSteamData
 */
export interface OWGameSteamData {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    detailedDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    genres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    developers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    publishers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    releaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    headerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    capsuleImage?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    capsuleImageV5?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    backgroundRaw?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    screenshots?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    categories?: Array<string>;
    /**
     * 
     * @type {OWGameSteamDataPlatforms}
     * @memberof OWGameSteamData
     */
    platforms?: OWGameSteamDataPlatforms;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    recommendations?: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    achievements?: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    dlc?: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    movies?: number;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    website?: string;
    /**
     * 
     * @type {OWGameSteamDataPcRequirements}
     * @memberof OWGameSteamData
     */
    pcRequirements?: OWGameSteamDataPcRequirements;
    /**
     * 
     * @type {OWGameSteamDataSupportInfo}
     * @memberof OWGameSteamData
     */
    supportInfo?: OWGameSteamDataSupportInfo;
}

/**
 * Check if a given object implements the OWGameSteamData interface.
 */
export function instanceOfOWGameSteamData(value: object): value is OWGameSteamData {
    return true;
}

export function OWGameSteamDataFromJSON(json: any): OWGameSteamData {
    return OWGameSteamDataFromJSONTyped(json, false);
}

export function OWGameSteamDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamData {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'detailedDescription': json['detailedDescription'] == null ? undefined : json['detailedDescription'],
        'genres': json['genres'] == null ? undefined : json['genres'],
        'developers': json['developers'] == null ? undefined : json['developers'],
        'publishers': json['publishers'] == null ? undefined : json['publishers'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'headerImage': json['headerImage'] == null ? undefined : json['headerImage'],
        'capsuleImage': json['capsuleImage'] == null ? undefined : json['capsuleImage'],
        'capsuleImageV5': json['capsuleImageV5'] == null ? undefined : json['capsuleImageV5'],
        'background': json['background'] == null ? undefined : json['background'],
        'backgroundRaw': json['backgroundRaw'] == null ? undefined : json['backgroundRaw'],
        'screenshots': json['screenshots'] == null ? undefined : json['screenshots'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'platforms': json['platforms'] == null ? undefined : OWGameSteamDataPlatformsFromJSON(json['platforms']),
        'recommendations': json['recommendations'] == null ? undefined : json['recommendations'],
        'achievements': json['achievements'] == null ? undefined : json['achievements'],
        'dlc': json['dlc'] == null ? undefined : json['dlc'],
        'movies': json['movies'] == null ? undefined : json['movies'],
        'website': json['website'] == null ? undefined : json['website'],
        'pcRequirements': json['pcRequirements'] == null ? undefined : OWGameSteamDataPcRequirementsFromJSON(json['pcRequirements']),
        'supportInfo': json['supportInfo'] == null ? undefined : OWGameSteamDataSupportInfoFromJSON(json['supportInfo']),
    };
}

export function OWGameSteamDataToJSON(json: any): OWGameSteamData {
    return OWGameSteamDataToJSONTyped(json, false);
}

export function OWGameSteamDataToJSONTyped(value?: OWGameSteamData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'name': value['name'],
        'description': value['description'],
        'shortDescription': value['shortDescription'],
        'detailedDescription': value['detailedDescription'],
        'genres': value['genres'],
        'developers': value['developers'],
        'publishers': value['publishers'],
        'releaseDate': value['releaseDate'],
        'headerImage': value['headerImage'],
        'capsuleImage': value['capsuleImage'],
        'capsuleImageV5': value['capsuleImageV5'],
        'background': value['background'],
        'backgroundRaw': value['backgroundRaw'],
        'screenshots': value['screenshots'],
        'categories': value['categories'],
        'platforms': OWGameSteamDataPlatformsToJSON(value['platforms']),
        'recommendations': value['recommendations'],
        'achievements': value['achievements'],
        'dlc': value['dlc'],
        'movies': value['movies'],
        'website': value['website'],
        'pcRequirements': OWGameSteamDataPcRequirementsToJSON(value['pcRequirements']),
        'supportInfo': OWGameSteamDataSupportInfoToJSON(value['supportInfo']),
    };
}

